<template>
  <div class="row">
    <div class="col-12 mb-4 p-0" style="background : #f8f8f8">
      <v-card>
        <div class="col-12 col-lg-4">
        <v-card-title>
           <v-text-field solo
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
      </div>
        <v-data-table
            :headers="headers"
            :items="categories"
            :search="search"
            sort-by="name"
            class="elevation-1"
            :loading="loadings.categories" loading-text="Chargement en cours..."
        >

          <template v-slot:top>
            <v-toolbar flat color="white">
              <h4>Mes Catégories Produits</h4>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialogCategory" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn style="background: #29B3A6;color: #fff" class="mb-2" v-on="on">
                    {{ 'Nouvelle catégorie' }}
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <h4 class="col-12 mb-0 pb-0">{{ formTitle }}</h4>
                  </v-card-title>

                  <v-card-text>
                  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                      <v-col cols="12" sm="6" md="12">
                        <label>Nom du produit</label>
                        <v-text-field v-model="produits_category._name" solo
                                      :rules="requiredRules"
                                      label="Nom"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="12" class="mt-0 pt-0">
                        <label>Description</label>
                        <v-textarea v-model="produits_category._description" solo
                                    :rules="requiredRules"
                                    rows="2"
                                    label="Description"></v-textarea>
                      </v-col>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" @click="dialogCategory = false, editingCategory = false">Annuler</v-btn>
                    <v-btn v-if="!editingCategory" :loading="loadings.categoriySaving" color="primary" @click="save">
                      Enrégistrer
                    </v-btn>
                    <v-btn v-if="editingCategory" :loading="loadings.categoriySaving" color="primary" @click="update">
                      Mettre a jour
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="text-align:  right">
              <v-menu
                  key="text"
                  rounded="b-xl">
                <template v-slot:activator="{ attrs, on }">

                  <v-icon

                      class="black--text "
                      v-bind="attrs"
                      v-on="on">mdi-dots-vertical
                  </v-icon>

                </template>
                <v-list>
                  <v-list-item
                      v-for="(action_item, index) in actions_items"
                      :key="index"
                      link
                      @click="editItemAction(item,index)">
                    <v-list-item-icon>
                      <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="action_item.title"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
         
          <template v-slot:no-data>
            {{ $t('no_data') }}
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import helpers from "../../mixins/helpers";
//import {mapState} from "vuex";
import {client} from "../../store/services/client";
import Swal from "sweetalert2";

export default {
  name: "ProduitsCategories",
  mixins: [helpers(this)],
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t('Nouvelle catégorie') : this.$t('categoriesproduits.update')
    },
    //...mapState('produitcategory/',['produitcategories'])
  },
  data() {
    return {
      valid: true,
      lazy: false,
      dialogCategory: false,
      search: '',
      loadings: {
        categories: false,
        categoriySaving: false,
      },
      dialog: false,
      requiredRules: [
        v => !!v || 'Ce champ est recquis',
      ],
      id: undefined,
      editedIndex: -1,
      editingCategory: false,
      errors: undefined,
      headers: [
        {
          text: 'Nom',
          align: 'start',
          sortable: true,
          value: '_name',
        },
        {text: 'Description', value: '_description'},
        {text: '', value: 'actions', sortable: false},
      ],
      actions_items: [
        {title: "Modifier", avatar: 'mdi-pencil'},
        {title: "Supprimer", avatar: 'mdi-delete'}
      ],
      categories: [],
      produits_category: {
        _name: "",
        _description: "",
      }
    }
  },
  mounted() {
    this.initialize()
  },
  methods: {
    async initialize() {
      this.getProductCategories()
    },
    getClass(item) {
      return `fa fa-2xl fa-${item._icon}`;
    },
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleEditCategorieProduct(item);
          break;
        case 1:
          this.toggleDeleteCategory(item);
      }
    },
    toggleEditCategorieProduct(item) {
      this.dialogCategory = true;
      this.editingCategory = true;
      this.produits_category = item;
    },
    async getProductCategories() {
      this.loadings.categories = true;
      const response = await client({
        method: 'get',
        url: '/marchand/category_product/get'
      })
          .then(resp => resp.data)
          .catch(error => {
            console.log(error)
            this.loadings.categories = false;
            return {
              error: "true"
            }
          })
      if (!response.error) {
        this.loadings.categories = false;
        this.categories = response.categorieproducts
      }
    },
    selectCategoryCustomerIcon(icon) {
      this.produits_category._icon = icon.className
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loadings.categoriySaving = true;
        const response = await client({
          method: 'post',
          url: '/marchand/category_product/post',
          data: this.produits_category
        })
            .then(resp => {
              this.categories = resp.data.categorieproducts;
              this.$refs.form.reset();
              return resp.data;
            })
            .catch(error => {
              console.log(error)
              return {
                error: "true"
              }
            })
        this.loadings.categoriySaving = false;
        this.dialogCategory = false;
        this.toast(response.type, response.message)
      }
    },
    async update() {
      if (this.$refs.form.validate()) {
        this.loadings.categoriySaving = true;
        const response = await client({
          method: 'post',
          url: '/marchand/category_product/update',
          data: this.produits_category
        })
            .then(resp => {
              this.categories = resp.data.categorieproducts;
              this.$refs.form.reset();
              return resp.data;
            })
            .catch(error => {
              console.log(error)
              return {
                error: "true"
              }
            })
        this.loadings.categoriySaving = false;
        this.editingCategory = false;
        this.dialogCategory = false;
        this.toast(response.type, response.message)
      }
    },
    toggleDeleteCategory(item) {
      Swal.fire({
        icon: 'warning',
        timerProgressBar: false,
        text: this.$t('delete_warning'),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading()
         await client({
            method: 'get',
            url: `/marchand/category_product/delete/${item._id}`,
          })
              .then(resp => {
                Swal.hideLoading()
                Swal.fire({
                  icon: 'success',
                  text: "Suppression réussi",
                  confirmButtonText: "Ok",
                  cancelButtonText: "Annuler",
                  cancelButtonColor: "#CCC",
                  confirmButtonColor: "#29B3A6"
                });
                this.categories = resp.data.categorieproducts;
                return resp.data;
              })
              .catch(error => {
                console.log(error)
                return {
                  error: "true"
                }
              })
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => result)
    }
  }
}
</script>

<style scoped>

</style>
